import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';
export function OfferBlock() {
  return <section className="py-24 bg-amber px-6 lg:px-8" data-id="element-134">
      <div className="max-w-4xl mx-auto text-center" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-136">
          <h2 className="text-4xl md:text-6xl font-bold text-forest mb-6 leading-tight" data-id="element-137">
            Stop living with your tank on empty.
          </h2>
          <p className="text-2xl text-forest/90 font-serif italic mb-12" data-id="element-138">
            Reclaim your biological right to steady energy.
          </p>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl max-w-2xl mx-auto border border-forest/10" data-id="element-139">
            <div className="mb-6" data-id="element-140">
              <p className="text-charcoal/60 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-141">
                Launch Price (Instant Access)
              </p>
              <div className="text-6xl font-bold text-forest font-serif" data-id="element-142">
                $6.70{' '}
                <span className="text-2xl text-charcoal/50 font-sans" data-id="element-143">USD</span>
              </div>
            </div>

            <div className="mb-8 p-4 bg-amber/10 border border-amber/30 rounded-xl flex items-center gap-3" data-id="element-144">
              <span className="bg-amber text-forest text-xs font-bold uppercase tracking-wider px-2 py-1 rounded shrink-0" data-id="element-145">
                Free Bonus
              </span>
              <div className="text-left" data-id="element-146">
                <p className="font-bold text-forest text-sm" data-id="element-147">
                  The Buyer's Compass
                </p>
                <p className="text-charcoal/60 text-xs" data-id="element-148">
                  How to read supplement labels in 60 seconds —{' '}
                  <span className="line-through" data-id="element-149">$10 value</span> included free
                </p>
              </div>
            </div>

            <a href="https://guias-salud.com/cart/46220211814588:1" target="_blank" rel="noopener noreferrer" className="w-full bg-forest text-white py-5 rounded-xl font-bold text-lg md:text-xl flex items-center justify-center gap-3 hover:bg-forest/90 transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg mb-6 group no-underline" data-id="element-150">
              I WANT TO START MY ENERGY RESET NOW!
              <ArrowRight className="group-hover:translate-x-1 transition-transform" data-id="element-151" />
            </a>

            <div className="flex items-center justify-center gap-2 text-charcoal/70 text-sm font-medium" data-id="element-152">
              <Download size={16} data-id="element-153" />
              <span data-id="element-154">
                Instant download. Start closing your nutritional gaps today.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}